<div class="relative">
  <button
    class="relative flex items-center justify-center text-gray-500 transition-colors bg-white border border-gray-200 rounded-full dropdown-toggle hover:text-gray-700 h-11 w-11 hover:bg-gray-100 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white"
    (click)="toggleDropdown()"
    [attr.aria-label]="unreadCount() ? ('notif.bellAriaUnread' | t: { count: unreadCount() }) : ('notif.bellAria' | t)"
  >
    @if (unreadCount() > 0) {
      <span class="absolute -right-0.5 -top-0.5 z-10 flex min-h-[18px] min-w-[18px] items-center justify-center rounded-full bg-brand-500 px-1 text-[10px] font-semibold leading-none text-white">
        {{ unreadCount() > 99 ? '99+' : unreadCount() }}
        <span class="absolute inline-flex h-full w-full rounded-full bg-brand-400 opacity-60 animate-ping"></span>
      </span>
    }
    <svg class="fill-current" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.75 2.29248C10.75 1.87827 10.4143 1.54248 10 1.54248C9.58583 1.54248 9.25004 1.87827 9.25004 2.29248V2.83613C6.08266 3.20733 3.62504 5.9004 3.62504 9.16748V14.4591H3.33337C2.91916 14.4591 2.58337 14.7949 2.58337 15.2091C2.58337 15.6234 2.91916 15.9591 3.33337 15.9591H4.37504H15.625H16.6667C17.0809 15.9591 17.4167 15.6234 17.4167 15.2091C17.4167 14.7949 17.0809 14.4591 16.6667 14.4591H16.375V9.16748C16.375 5.9004 13.9174 3.20733 10.75 2.83613V2.29248ZM14.875 14.4591V9.16748C14.875 6.47509 12.6924 4.29248 10 4.29248C7.30765 4.29248 5.12504 6.47509 5.12504 9.16748V14.4591H14.875ZM8.00004 17.7085C8.00004 18.1228 8.33583 18.4585 8.75004 18.4585H11.25C11.6643 18.4585 12 18.1228 12 17.7085C12 17.2943 11.6643 16.9585 11.25 16.9585H8.75004C8.33583 16.9585 8.00004 17.2943 8.00004 17.7085Z" fill="currentColor" />
    </svg>
  </button>

  <app-dropdown
    [isOpen]="isOpen()"
    (close)="closeDropdown()"
    className="absolute -right-[240px] mt-[17px] flex h-[480px] w-[350px] flex-col rounded-2xl border border-gray-200 bg-white p-3 shadow-theme-lg dark:border-gray-800 dark:bg-gray-dark sm:w-[361px] max-lg:left-0 min-lg:right-0"
  >
    <div class="flex items-center justify-between pb-3 mb-3 border-b border-gray-100 dark:border-gray-700">
      <h5 class="text-lg font-semibold text-gray-800 dark:text-gray-200">
        {{ 'notif.title' | t }}
        @if (unreadCount() > 0) {
          <span class="ml-1 text-sm font-medium text-brand-600 dark:text-brand-400">({{ unreadCount() }})</span>
        }
      </h5>
      <div class="flex items-center gap-2">
        @if (unreadCount() > 0) {
          <button (click)="markAllRead()" class="text-xs font-medium text-brand-600 transition hover:text-brand-700 dark:text-brand-400">
            {{ 'notif.markAll' | t }}
          </button>
        }
        <button (click)="closeDropdown()" class="text-gray-500 transition dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200" [attr.aria-label]="'common.close' | t">
          <svg class="fill-current" width="22" height="22" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.21967 7.28131C5.92678 6.98841 5.92678 6.51354 6.21967 6.22065C6.51256 5.92775 6.98744 5.92775 7.28033 6.22065L11.999 10.9393L16.7176 6.22078C17.0105 5.92789 17.4854 5.92788 17.7782 6.22078C18.0711 6.51367 18.0711 6.98855 17.7782 7.28144L13.0597 12L17.7782 16.7186C18.0711 17.0115 18.0711 17.4863 17.7782 17.7792C17.4854 18.0721 17.0105 18.0721 16.7176 17.7792L11.999 13.0607L7.28033 17.7794C6.98744 18.0722 6.51256 18.0722 6.21967 17.7794C5.92678 17.4865 5.92678 17.0116 6.21967 16.7187L10.9384 12L6.21967 7.28131Z" fill="currentColor" />
          </svg>
        </button>
      </div>
    </div>

    <ul class="flex flex-col flex-1 overflow-y-auto custom-scrollbar">
      @if (loading() && items().length === 0) {
        <li class="flex flex-1 items-center justify-center py-10 text-sm text-gray-500 dark:text-gray-400">
          <svg class="mr-2 h-5 w-5 animate-spin text-brand-500" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-opacity="0.25" />
            <path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
          </svg>
          {{ 'common.loading' | t }}
        </li>
      } @else if (error()) {
        <li class="flex flex-1 flex-col items-center justify-center gap-2 py-10 text-center text-sm text-gray-500 dark:text-gray-400">
          <span>{{ error() }}</span>
          <button (click)="load()" class="text-xs font-medium text-brand-600 hover:underline dark:text-brand-400">{{ 'common.retry' | t }}</button>
        </li>
      } @else if (items().length === 0) {
        <li class="flex flex-1 flex-col items-center justify-center gap-2 py-10 text-center">
          <span class="flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 text-gray-400 dark:bg-gray-800">
            <svg width="22" height="22" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 2.5c-3.18 0-5.75 2.57-5.75 5.75v4.46h-.17a.75.75 0 0 0 0 1.5h11.84a.75.75 0 0 0 0-1.5h-.17V8.25C15.75 5.07 13.18 2.5 10 2.5Z"/></svg>
          </span>
          <p class="text-sm text-gray-500 dark:text-gray-400">{{ 'notif.emptyDropdown' | t }}</p>
        </li>
      } @else {
        @for (n of items(); track n.id) {
          <li>
            <button
              type="button"
              (click)="onItemClick(n)"
              class="flex w-full gap-3 rounded-lg border-b border-gray-100 p-3 text-left transition hover:bg-gray-100 dark:border-gray-800 dark:hover:bg-white/5"
              [class.bg-brand-50]="!n.read"
              [class.dark:bg-brand-500/10]="!n.read"
            >
              <!-- Icône par type -->
              <span
                class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full"
                [class.bg-brand-50]="typeMeta[n.type].palette === 'brand'"
                [class.text-brand-600]="typeMeta[n.type].palette === 'brand'"
                [class.bg-blue-light-50]="typeMeta[n.type].palette === 'blue-light'"
                [class.text-blue-light-600]="typeMeta[n.type].palette === 'blue-light'"
                [class.bg-warning-50]="typeMeta[n.type].palette === 'warning'"
                [class.text-warning-600]="typeMeta[n.type].palette === 'warning'"
                [class.bg-error-50]="typeMeta[n.type].palette === 'error'"
                [class.text-error-600]="typeMeta[n.type].palette === 'error'"
                [class.bg-gray-100]="typeMeta[n.type].palette === 'gray'"
                [class.text-gray-500]="typeMeta[n.type].palette === 'gray'"
                [class.dark:bg-white/5]="true"
              >
                @switch (typeMeta[n.type].icon) {
                  @case ('rental') {
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M6.5 5.75A1.25 1.25 0 0 0 5.3 6.62l-1.05 3.13H3.75a.75.75 0 0 0-.75.75V14a.75.75 0 0 0 .75.75H4.5v1.5a1.25 1.25 0 1 0 2.5 0v-1.5h10v1.5a1.25 1.25 0 1 0 2.5 0v-1.5h.75A.75.75 0 0 0 21 14v-3.5a.75.75 0 0 0-.75-.75h-.5L18.7 6.62A1.25 1.25 0 0 0 17.5 5.75h-11Z"/></svg>
                  }
                  @case ('vehicle') {
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M6.5 5.75A1.25 1.25 0 0 0 5.3 6.62l-1.05 3.13H3.75a.75.75 0 0 0-.75.75V14a.75.75 0 0 0 .75.75H4.5v1.5a1.25 1.25 0 1 0 2.5 0v-1.5h10v1.5a1.25 1.25 0 1 0 2.5 0v-1.5h.75A.75.75 0 0 0 21 14v-3.5a.75.75 0 0 0-.75-.75h-.5L18.7 6.62A1.25 1.25 0 0 0 17.5 5.75h-11Z"/></svg>
                  }
                  @case ('contract') {
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M8 4h6l4 4v12H6V4h2Z" stroke-linejoin="round"/><path d="M14 4v4h4M9 13h6M9 16h4" stroke-linecap="round"/></svg>
                  }
                  @case ('chat') {
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 5h16v11H8l-4 3V5Z" stroke-linejoin="round"/></svg>
                  }
                  @default {
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><path d="M12 8h.01M11 12h1v4h1" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  }
                }
              </span>

              <span class="block min-w-0 flex-1">
                <span class="mb-0.5 block truncate text-theme-sm text-gray-700 dark:text-gray-200" [class.font-semibold]="!n.read">
                  {{ text(n) }}
                </span>
                <span class="flex items-center gap-2 text-gray-500 text-theme-xs dark:text-gray-400">
                  <span>{{ relativeTime(n.createdAt) }}</span>
                </span>
              </span>

              @if (!n.read) {
                <span class="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-brand-500"></span>
              }
            </button>
          </li>
        }
      }
    </ul>

    <!-- Toggle push web (FCM) — visible seulement si le navigateur le supporte -->
    @if (push.supported()) {
      <div class="mt-3 flex items-center justify-between gap-3 rounded-lg border border-gray-200 px-3 py-2.5 dark:border-gray-800">
        <div class="flex items-center gap-2 min-w-0">
          <svg class="h-4 w-4 shrink-0 text-gray-400" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 1.5a5.67 5.67 0 0 0-5.67 5.67v3.16l-.92 2.2A.75.75 0 0 0 4.1 13.6h11.8a.75.75 0 0 0 .69-1.07l-.92-2.2V7.17A5.67 5.67 0 0 0 10 1.5ZM8 16a2 2 0 0 0 4 0H8Z"/></svg>
          <span class="truncate text-xs font-medium text-gray-600 dark:text-gray-300">
            @if (push.permission() === 'denied') {
              {{ 'notif.pushBlocked' | t }}
            } @else if (push.enabled()) {
              {{ 'notif.pushEnabled' | t }}
            } @else {
              {{ 'notif.pushEnable' | t }}
            }
          </span>
        </div>
        @if (push.permission() === 'denied') {
          <span class="shrink-0 text-[11px] text-gray-400">{{ 'notif.pushUnblockHint' | t }}</span>
        } @else {
          <button
            type="button"
            (click)="togglePush()"
            [disabled]="push.busy()"
            [class.bg-brand-500]="push.enabled()"
            [class.bg-gray-300]="!push.enabled()"
            [class.dark:bg-gray-700]="!push.enabled()"
            class="relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition disabled:opacity-50"
            [attr.aria-pressed]="push.enabled()"
            [attr.aria-label]="'notif.pushToggleAria' | t"
          >
            <span
              class="inline-block h-4 w-4 transform rounded-full bg-white shadow transition"
              [class.translate-x-4]="push.enabled()"
              [class.translate-x-1]="!push.enabled()"
            ></span>
          </button>
        }
      </div>
    }

    <a
      routerLink="/notifications"
      (click)="closeDropdown()"
      class="mt-3 block rounded-lg border border-gray-300 bg-white px-4 py-2 text-center text-sm font-medium text-gray-700 transition hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700"
    >
      {{ 'notif.viewAll' | t }}
    </a>
  </app-dropdown>
</div>
